module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_03-9fcd79e05760b021a6d7d6e83bad4c02.webp";